import { useRef, useState, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ScheduleIcon from '@material-ui/icons/Schedule';
import Router from 'next/router';
import CopyEventButton from './copy-event-button';

const useStyles = makeStyles((theme) => ({
  seriesIcon: {
    marginRight: theme.spacing(0.5),
  },
}));

const EventDuplicateDropdown = (props) => {
  const { event, ...rest } = props;
  const classes = useStyles();
  const buttonRef = useRef();

  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);

  const handleConvertToSeries = useCallback(() => {
    Router.push(
      `/event-series/new?convertEventId=${event.id}`,
    );
  }, [event]);
  const handleManageSeries = useCallback(() => {
    Router.push(
      '/event-series/[id]/schedule',
      `/event-series/${event.series.id}/schedule`,
    );
  }, [event]);

  return (
    <Fragment>
      <Button
        aria-controls={`duplicate-dropdown-${event.id}`}
        aria-haspopup="true"
        onClick={handleOpen}
        ref={buttonRef}
        {...rest}
      >
        Duplicate
      </Button>
      <Menu
        id={`duplicate-dropdown-${event.id}`}
        anchorEl={buttonRef.current}
        getContentAnchorEl={null}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {event.series ? (
          <MenuItem
            onClick={handleManageSeries}
          >
            <ScheduleIcon className={classes.seriesIcon} /> Manage Series
          </MenuItem>
        ) : (
          <MenuItem onClick={handleConvertToSeries}>
            Convert to Series
          </MenuItem>
        )}
        <CopyEventButton
          buttonComponent={MenuItem}
          event={event}
        >
          Copy Event
        </CopyEventButton>
      </Menu>
    </Fragment>
  );
};

EventDuplicateDropdown.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDuplicateDropdown;
